export const AUTO_LOGIN = true;
export const ALLOW_FRESH_SIGNUP_MCP_REGISTER_REDIRECT = false;

export const PUBLIC_ROUTES = Object.freeze([
  "/",
  "/background",
  "/product",
  "/technology",
  "/faq",
  "/contact",
  "/link/agent",
  "/login",
  "/register",
] as const);

export const REDIRECT_PUBLIC_HOME = "/";
export const REDIRECT_PRIVATE_HOME = "/studio";
export const REDIRECT_LOGIN = "/login";
export const REDIRECT_REGISTER = "/register";
export const REDIRECT_UNAUTHORIZED = "/unauthorized";
export const REDIRECT_ERROR = "/error";
export const REDIRECT_INITIALIZE_ACCOUNT = "/initialize-account";
export const REDIRECT_BACKLOG = "/backlog";
export const REDIRECT_OAUTH_CONSENT = "/oauth/consent";
export const REDIRECT_OAUTH_DECISION = "/api/oauth/decision";

export const authSettings = Object.freeze({
  autoLogin: AUTO_LOGIN,
  allowFreshSignupMcpRegisterRedirect: ALLOW_FRESH_SIGNUP_MCP_REGISTER_REDIRECT,
  publicRoutes: PUBLIC_ROUTES,
  redirects: {
    publicHome: REDIRECT_PUBLIC_HOME,
    privateHome: REDIRECT_PRIVATE_HOME,
    login: REDIRECT_LOGIN,
    register: REDIRECT_REGISTER,
    unauthorized: REDIRECT_UNAUTHORIZED,
    error: REDIRECT_ERROR,
    initializeAccount: REDIRECT_INITIALIZE_ACCOUNT,
    backlog: REDIRECT_BACKLOG,
    oauthConsent: REDIRECT_OAUTH_CONSENT,
    oauthDecision: REDIRECT_OAUTH_DECISION,
  },
});

export default authSettings;
